// extracted by mini-css-extract-plugin
export default {"container":"RatingModal_container__-iZ1+"};